// @flow

import * as React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import {actionsRolesAllow} from './ActionsRolesAllow';
import type {RoleDescriptionProps} from './RoleDescription';

const viewOnlyRoleMessages = defineMessages({
  roleName: {
    id: 'docsApp.components.contrib.roleDescriptions.viewOnly.roleName',
    description: 'The name of the view only role.',
    defaultMessage: 'View Only',
  },
  descriptionOfWhatRoleCanDo: {
    id:
      'docsApp.components.contrib.roleDescriptions.viewOnly.descriptionOfWhatRoleCanDo',
    description: 'The description of what the view only role can do.',
    defaultMessage:
      'This role is for people who need to view payments, balance, and connected accounts, but can’t edit any of them. This role can also export data and download reports.',
  },
  descriptionOfWhatRoleCannotDo: {
    id:
      'docsApp.components.contrib.roleDescriptions.viewOnly.descriptionOfWhatRoleCannotDo',
    description: "The description of what the view only role can't do.",
    defaultMessage:
      "They can't create connected accounts, transfer funds, payout money, or edit any account and product settings.",
  },
});

const viewOnlyRoleDescriptionProps: RoleDescriptionProps = {
  roleName: <FormattedMessage {...viewOnlyRoleMessages.roleName} />,
  roleExternalId: 'view_only',
  isBeta: false,
  descriptionOfWhatRoleCanDo: (
    <FormattedMessage {...viewOnlyRoleMessages.descriptionOfWhatRoleCanDo} />
  ),
  descriptionOfWhatRoleCannotDo: (
    <FormattedMessage {...viewOnlyRoleMessages.descriptionOfWhatRoleCannotDo} />
  ),
  someThingsThisRoleCanDo: [
    <FormattedMessage {...actionsRolesAllow.viewDisputes} />,
    <FormattedMessage {...actionsRolesAllow.viewPayments} />,
    <FormattedMessage {...actionsRolesAllow.viewProducts} />,
    <FormattedMessage {...actionsRolesAllow.viewCustomers} />,
    <FormattedMessage {...actionsRolesAllow.viewConnectedAccounts} />,
    <FormattedMessage {...actionsRolesAllow.viewBalance} />,
    <FormattedMessage {...actionsRolesAllow.viewTransfers} />,
    <FormattedMessage {...actionsRolesAllow.viewRadar} />,
    <FormattedMessage {...actionsRolesAllow.viewEventsAndLogs} />,
    <FormattedMessage {...actionsRolesAllow.manageFinancialReports} />,
    <FormattedMessage {...actionsRolesAllow.bulkExport} />,
    <FormattedMessage {...actionsRolesAllow.viewPayouts} />,
  ],
  someThingsThisRoleCannotDo: [
    <FormattedMessage {...actionsRolesAllow.resolveDisputes} />,
    <FormattedMessage {...actionsRolesAllow.createRefundPayments} />,
    <FormattedMessage {...actionsRolesAllow.createEditDeleteProducts} />,
    <FormattedMessage {...actionsRolesAllow.createEditDeleteCustomers} />,
    <FormattedMessage
      {...actionsRolesAllow.createEditRejectConnectedAccounts}
    />,
    <FormattedMessage
      {...actionsRolesAllow.transferBalanceAndReverseTransfers}
    />,
    <FormattedMessage
      {...actionsRolesAllow.payoutBalanceToExternalBankAccount}
    />,
    <FormattedMessage {...actionsRolesAllow.editPayoutSchedule} />,
    <FormattedMessage {...actionsRolesAllow.addAndEditBankAccountDetails} />,
    <FormattedMessage {...actionsRolesAllow.createEditDeleteAPIKeys} />,
    <FormattedMessage {...actionsRolesAllow.addEditRemoveTeamMembers} />,
    <FormattedMessage {...actionsRolesAllow.editAccountDetails} />,
    <FormattedMessage {...actionsRolesAllow.changeAccountOwner} />,
    <FormattedMessage {...actionsRolesAllow.configureAnyProductSettings} />,
    <FormattedMessage
      {...actionsRolesAllow.connectAccountToConnectPlatforms}
      values={{
        a: (content) => <a href="https://stripe.com/docs/connect">{content}</a>,
      }}
    />,
  ],
};

export const allViewOnlyRoleProps = [viewOnlyRoleDescriptionProps];
